import { FiberManualRecord } from "@mui/icons-material";
import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import { REPORT_SEVERITY_MAP } from "static/constants";
import { capitalizeFirstLetter } from "utils/string";

const IdentifiedAlert = ({ suggestion, alert, index }) => {
  return (
    <Grid
      item
      container
      key={index}
      flexDirection="row"
      alignItems="center"
      gap={0.5}
    >
      <FiberManualRecord
        style={{
          color: REPORT_SEVERITY_MAP[capitalizeFirstLetter(alert)],
        }}
        className="severity-icon"
        value={alert}
      />
      <Typography className="identified-label">
        {capitalizeFirstLetter(alert)}
      </Typography>
      <Divider className="content-divider" />
      <Typography className="identified-label">
        {`${suggestion?.episodes?.[index] ?? ""} ${
          suggestion?.values?.[index] ?? ""
        }`}
      </Typography>
      <Divider className="content-divider" />
      <Typography className="identified-label">
        Page No.: {suggestion?.pageNumbers?.[index]}
      </Typography>
    </Grid>
  );
};

export default IdentifiedAlert;
